import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from 'reactstrap';

const FilterSetRenameModal = ({ isOpen, option, onConfirm, onClose }) => {
  const [renameValue, setRenameValue] = useState(option?.label || '');

  const handleConfirm = () => {
    const newName = renameValue.trim();
    if (!newName || !option) return;
    onConfirm?.({ id: option.value, newName });
    onClose?.();
  };

  const handleClose = () => {
    setRenameValue('');
    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} onOpened={() => setRenameValue(option?.label || '')} modalClassName="filters-set-save-modal">
      <ModalHeader toggle={handleClose}>Rename Filter Set</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ color: 'black', fontWeight: '500' }} className="main-header pt-2 pb-2">
          Enter a new name for this filter set.
        </div>
        <Input
          autoFocus
          id="rename-filter-set-input"
          placeholder="New Filter Set Name"
          value={renameValue}
          onChange={(e) => setRenameValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleConfirm();
            }
          }}
        />
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button style={{color: 'white'}} color="blueFilter" onClick={handleConfirm} disabled={!renameValue.trim()}>Confirm</Button>
      </ModalFooter>
    </Modal>
  );
};

export default FilterSetRenameModal;
